import { useWalletOptionsDialogOpen } from '@/providers/ModalOpenStateProvider'
import { formatAccountAddress } from '@/utilities/formatters'
import { Button } from '@blockpot-dev/block-pot-design-system'
import { Wallet } from 'lucide-react'
import Image from 'next/image'
import { Address, GetEnsAvatarReturnType, GetEnsNameReturnType } from 'viem'
import { useAccount, useDisconnect, useEnsAvatar, useEnsName } from 'wagmi'

export type PureConnectWalletItemProps = {
    walletAddress: Address | undefined
    ensName: GetEnsNameReturnType | undefined
    ensAvatar: GetEnsAvatarReturnType | undefined
    connect: () => void
    disconnect: () => void
}

export function PureConnectWalletItem(props: PureConnectWalletItemProps) {
    const { walletAddress, ensName, ensAvatar, connect, disconnect } = props

    if (!walletAddress) {
        return (
            <Button size='sm' className='h-[40px] flex items-center gap-2 justify-center rounded-sm px-3 cursor-pointer' onClick={connect}>
                Connect Wallet
            </Button>
        )
    } else {
        return (
            <Button variant='outline' size='sm' className='h-[40px] flex items-center gap-2 justify-center rounded-sm bg-gray-950 px-3 cursor-pointer' onClick={disconnect}>
                {
                    ensAvatar ? (
                        <Image src={ensAvatar} alt='' width={24} height={24} />
                    ) : (
                        <Wallet className='size-5' strokeWidth={1.5} />
                    )
                }
                <span className='text-foreground font-bold normal-case'>
                    {ensName ?? formatAccountAddress(walletAddress.toUpperCase() ?? '')}
                </span>
            </Button>
        )
    }

}

export default function ConnectWalletItem() {
    const { address } = useAccount()
    const { disconnect } = useDisconnect()
    const { data: ensName } = useEnsName({ address, chainId: 1 })
    const { data: ensAvatar } = useEnsAvatar({ name: ensName!, chainId: 1 })
    const walletOptionsDialogOpen = useWalletOptionsDialogOpen()

    return (
        <PureConnectWalletItem
            walletAddress={address}
            ensName={ensName}
            ensAvatar={ensAvatar}
            disconnect={disconnect}
            connect={() => walletOptionsDialogOpen.update(true)}
        />
    )
}